import React, { Component } from 'react'
import { DatePicker, Select, Input, Table, Spin, Button, Popover } from 'antd'
import { app } from '../../app'
import moment from 'moment'
import utils from '../../utils'
import { getStencilList, getSendRecordList } from './message_api'


const Option = Select.Option

class MSendRecord extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            total: 0,
            data_loading: false,
            dataList: [],
            moduleList: [],
            module_loading: true,
            filter_date: undefined,
            filter_status: '0',
            filter_module: '0',
            filter_phone: '',
            current_time: moment(),
        }
    }

    async componentDidMount () {
        this._isMounted = true
        const state = { moduleList: await getStencilList(), module_loading: false }
        const msrs = sessionStorage.getItem('message-send-record-status')
        if (msrs) {
            state.filter_status = msrs
            sessionStorage.removeItem('message-send-record-status')
        }
        await this.setData(state)
        await this.dataSource(1)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据列表
     * @param page
     * @returns {Promise<void>}
     */
    dataSource = async (page) => {
        const state = { data_loading: true }
        if (page) {
            state.page = page
        } else {
            page = this.state.page
        }
        await this.setData(state)
        const { team } = this.props, { filter_date, filter_status, filter_module, filter_phone } = this.state
        const params = {
            page,
            type: team.type,
            object_name: team.key
        }
        if (filter_date) params.create_time = filter_date.format('YYYY-MM-DD')
        if (filter_status && filter_status !== '0') params.send_status = filter_status
        if (filter_module && filter_module !== '0') params.template_code = filter_module
        if (filter_phone) params.mobile = filter_phone
        const { data, total, time } = await getSendRecordList(params)
        await app.sleep(500)
        if (page === this.state.page) {
            const state2 = {
                dataList: utils.addArrayKey(data),
                total,
                data_loading: false,
                current_time: time
            }
            if (!this.state.filter_date) state2.filter_date = time
            await this.setData(state2)
        }
    }

    render () {
        let { dataList, page, total, data_loading, moduleList, module_loading, current_time, filter_date, filter_status } = this.state,
            columns = [
                {
                    title: '手机号码',
                    dataIndex: 'mobile',
                    key: 'mobile',
                    width: '15%'
                },
                {
                    title: '时间',
                    dataIndex: 'send_date',
                    key: 'send_date',
                    width: '15%',
                    render: (send_date, { receive_date }) => {
                        return (
                            <div style={{ textAlign: 'left' }}>
                                <div>
                                    <div>发送时间:</div>
                                    <div>{send_date || ' - '}</div>
                                </div>
                                <div style={{ marginTop: 15 }}>
                                    <div>接收时间:</div>
                                    <div>{receive_date || ' - '}</div>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '短信模板',
                    dataIndex: 'template_name',
                    key: 'template_name',
                    width: '15%',
                    render: (template_name, { template_code }) => (<span>（{template_code}）{template_name}</span>)
                },
                {
                    title: '短信内容',
                    dataIndex: 'content',
                    key: 'content',
                    width: '20%',
                    render: (content) => (<div style={{ textAlign: 'left' }}>{content}</div>)
                },
                {
                    title: '短信字数',
                    dataIndex: 'sms_size',
                    key: 'sms_size',
                    width: '10%'
                },
                {
                    title: '计费条数',
                    dataIndex: 'sms_count',
                    key: 'sms_count',
                    width: '10%'
                },
                {
                    title: '发送状态',
                    dataIndex: 'send_status',
                    key: 'send_status',
                    width: '15%',
                    render: (send_status, { msg, suggest }) => {
                        let color = '#ccc', text = '发送失败'
                        switch (send_status) {
                            case '1':
                                text = '已发送未回执'
                                break
                            case '2':
                                text = '发送失败'
                                color = '#ff9900'
                                break
                            case '3':
                                text = '发送成功'
                                color = '#19be6b'
                                break
                        }
                        return (
                            <span>
                                <i className="pt-status-circle" style={{ backgroundColor: color }}/>
                                <span>{text}</span>
                                {
                                    send_status === '2' ? (
                                        <Popover title={(
                                            <div style={{ textAlign: 'center', fontWeight: '600' }}>失败详细</div>)}
                                                 content={(
                                                     <div style={{ width: 240 }}>
                                                         <div>
                                                             <div>原因：</div>
                                                             <p style={{ paddingLeft: 10 }}>{msg || '未知'}</p>
                                                         </div>
                                                         <div>
                                                             <div>建议：</div>
                                                             <p style={{ paddingLeft: 10 }}>{suggest || '暂无'}</p>
                                                         </div>
                                                     </div>
                                                 )} placement="bottomLeft">
                                            <span className="m-link" style={{ marginLeft: 6 }}>详细</span>
                                        </Popover>
                                    ) : null
                                }
                            </span>
                        )
                    }
                }
            ]
        return (
            <div className="message-sendrecord-page">
                <div className="msp-filter">
                    <div className="pf-row">
                        <span className="pf-item">
                            <label>发送日期:</label>
                            <DatePicker size="small" format="YYYY年MM月DD日" value={filter_date}
                                        disabledDate={current => current && current > current_time.endOf('day')}
                                        onChange={v => this.setData({ filter_date: v })}
                            />
                        </span>
                        <span className="pf-item">
                            <label htmlFor="pf-phone">手机号码:</label>
                            <Input id="pf-phone" placeholder="请输入手机号搜索" size="small" style={{ width: 140 }}
                                   onChange={e => this.setData({ filter_phone: e.target.value })} maxLength={11}/>
                        </span>
                        <span className="pf-item">
                            <label>发送状态:</label>
                            <Select value={filter_status || '0'} size="small" style={{ width: 160 }}
                                    onChange={v => this.setData({ filter_status: v })}>
                                <Option value="0">全部</Option>
                                <Option value="3">发送成功</Option>
                                <Option value="2">发送失败</Option>
                                <Option value="1">已发送未回执</Option>
                            </Select>
                        </span>
                        <span className="pf-item">
                            <label>短信模板:</label>
                            <Select defaultValue="0" size="small" style={{ width: 160 }}
                                    onChange={v => this.setData({ filter_module: v })}
                                    notFoundContent={module_loading ? (<Spin size="small"/>) : null}
                            >
                                <Option value="0">全部</Option>
                                {
                                    moduleList.map(m => (
                                        <Option key={m.template_code}>{m.name}</Option>
                                    ))
                                }
                            </Select>
                        </span>
                        <Button size="small" style={{ marginLeft: 20 }} onClick={() => this.dataSource(1)}>查询</Button>
                    </div>
                    {/*<div className="pf-row">*/}
                    {/*<span className="pf-item">*/}
                    {/*<label for="pf-plate">横版:</label>*/}
                    {/*<Select id="pf-plate" defaultValue="0" size="small" style={{ width: 160 }}>*/}
                    {/*<Option value="0">全部</Option>*/}
                    {/*<Option value="1">发送成功</Option>*/}
                    {/*<Option value="2">发送失败</Option>*/}
                    {/*</Select>*/}
                    {/*</span>*/}
                    {/*</div>*/}
                </div>
                <Table
                    columns={columns}
                    dataSource={dataList}
                    size="small"
                    bordered
                    loading={data_loading}
                    locale={app.tbLocale(data_loading)}
                    className="mp-table table-odd-even-row"
                    pagination={{
                        current: page,
                        total: total,
                        pageSize: 20,
                        showTotal: (t) => `总共${t}条.`,
                        onChange: this.dataSource
                    }}
                />

            </div>
        )
    }
}

export default MSendRecord



// WEBPACK FOOTER //
// ./src/routes/message/MSendRecord.jsx